import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { SettingsService } from '@infodata-group/inf-commons';
import { PreferencesSettingsKeyEnum } from '../../enum/preferences-settings-key.enum';
import { AoSharedTools } from '../../engine/tools/ao-shared-tools';

@Component({
  selector: 'ao-shared-legend-path',
  templateUrl: './legend-path.component.html',
  styleUrls: ['./legend-path.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: true,
})
export class LegendPathComponent {
  public settingsService = inject(SettingsService);

  public colors = AoSharedTools.getColorPath(
    this.settingsService.getSetting(PreferencesSettingsKeyEnum.speedAndColor)
  );
}
